<div class="filters-box" [@toggleBox]="isBoxOpened ? 'open' : 'closed'">
  <div class="filters-box__header" (click)="setIsBoxOpened()">
    <!-- box title -->
    <div class="box-title">
      <span class="box-title__icon">
        <i class="iconsax" [attr.icon-name]="boxIcon()"></i>
      </span>
      <h3 class="box-title__text">
        {{ boxTitle() | translate }}
      </h3>
    </div>

    <!-- box toggle btn -->
    @if (isClosableBox()) {
      <div>
        <button class="box-toggle-btn">
          <i
            class="iconsax"
            [attr.icon-name]="isBoxOpened ? 'chevron-up' : 'chevron-down'"></i>
        </button>
      </div>
    }
  </div>

  <!-- box filters -->
  @if (isBoxOpened) {
    <form [formGroup]="filtersForm">
      <ul
        class="filters-box__body custom-scrollbar"
        [ngClass]="{ '!mt-0': filtersType() === 'range' }">
        <!-- check box mode -->
        @if (filtersType() === 'checkbox') {
          <!-- single filters -->
          @for (item of filterItems(); track $index) {
            <li>
              @if (isFilterByIdMode()) {
                <div>
                  <pwj-checkbox
                    [label]="
                      (!!filterPrefix()
                        ? filterPrefix() + ((item?.name | translateData) || '')
                        : (item?.name | translateData)) +
                      (filterSuffix() ? ' ' + filterSuffix() : '')
                    "
                    [formControlName]="item._id"
                    (input)="setFiltersInParams()"></pwj-checkbox>
                </div>
              } @else {
                <div>
                  @if (isCategoryFiltering()) {
                    <pwj-checkbox
                      [label]="
                        (!!filterPrefix()
                          ? filterPrefix() +
                            ((item?.name | translateData) || '')
                          : (item?.name | translateData) || '') +
                        (filterSuffix() ? ' ' + filterSuffix() : '')
                      "
                      [formControlName]="item?._id"
                      (input)="setCategoriesFilter(item?._id)"></pwj-checkbox>
                  } @else {
                    <pwj-checkbox
                      [label]="
                        (!!filterPrefix()
                          ? filterPrefix() + ((item | translateData) || '')
                          : (item | translateData) || '') +
                        (filterSuffix() ? ' ' + filterSuffix() : '')
                      "
                      [formControlName]="item"
                      (input)="setFiltersInParams()"></pwj-checkbox>
                  }
                </div>
              }
            </li>
          }
        } @else if (filtersType() === 'staged') {
          @for (item of filterItems(); track $index) {
            <div>
              <pwj-staged-input
                [label]="item"
                [formControlName]="item"
                (change)="setFiltersInParams()"></pwj-staged-input>
            </div>
          }
        } @else if (filtersType() === 'radioButton') {
          @for (item of filterItems(); track item?._id) {
            <div
              (click)="handleRadioButton(filterQueryName() || '', item?._id)">
              <pwj-radio-button
                [label]="
                  (!!filterPrefix()
                    ? filterPrefix() + ((item?.name | translateData) || '')
                    : (item?.name | translateData) || '') +
                  (filterSuffix() ? ' ' + filterSuffix() : '')
                "
                [formControlName]="filterQueryName() || ''"
                [filterName]="filterQueryName() || ''"
                [value]="item?._id"
                (change)="setFiltersInParams()">
              </pwj-radio-button>
            </div>
          }
        } @else if (filtersType() === 'range') {
          <li class="filters-box__range-container">
            <pwj-range-input
              [minRange]="priceRange()?.min || 0"
              [maxRange]="priceRange()?.max || 100"
              [rangeStep]="priceRange()?.step || 10"
              formControlName="priceRange"
              (change)="setFiltersInParams()"></pwj-range-input>
          </li>
        }
      </ul>
    </form>

    <!-- remove filters button for radio button -->
    @if (filtersType() === 'radioButton') {
      <div class="filters-box__remove-btn-container">
        <pwj-button
          size="large"
          icon="trash"
          iconClasses="!text-4xl"
          (click)="onDeleteRadioBtnFilter()">
          {{ 'advanceFiltering.removeTheFilter' | translate }}
        </pwj-button>
      </div>
    }
  }
</div>
